// Hooks
import React, { FC } from 'react';

//component

import { SampleNextArrow, SamplePrevArrow } from 'modules/global/SampleArrows';
import { BrandsArrayType, CompaniesArrayType } from 'types/api/itemsResponseType';
import { RelatedCompaniesAndBrandsItem } from './RelatedCompaniesAndBrandsItem';
import { RelatedCompaniesAndBrandsWrap, SliderUI } from './style';

type PropsType = {
  settings?: any;
  brandItems: BrandsArrayType;
  companiesItems: CompaniesArrayType;
};

export const RelatedCompaniesAndBrands: FC<PropsType> = ({
  settings = {},
  brandItems,
  companiesItems,
}) => {
  const validArrays = [brandItems, companiesItems].filter(
    arr => Array.isArray(arr) && arr.length > 0
  );
  // @ts-ignore
  const items = [].concat(...validArrays);

  const extSettings = {
    draggable: false,
    infinite: items.length > 3,
    speed: 500,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [],
    ...settings,
  };

  if (items.length <= 1) {
    return (
      <RelatedCompaniesAndBrandsWrap>
        {items.map((item: any) => {
          return (
            <React.Fragment key={item.id}>
              <RelatedCompaniesAndBrandsItem item={item} />
            </React.Fragment>
          );
        })}
      </RelatedCompaniesAndBrandsWrap>
    );
  } else {
    return (
      <RelatedCompaniesAndBrandsWrap>
        <SliderUI {...extSettings}>
          {items.map((item: any) => {
            return (
              <React.Fragment key={item?.id}>
                <RelatedCompaniesAndBrandsItem item={item} />
              </React.Fragment>
            );
          })}
        </SliderUI>
      </RelatedCompaniesAndBrandsWrap>
    );
  }
};

export default RelatedCompaniesAndBrands;
